"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserStatus = UserStatus;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = require("styled-components");

var _oxygenConfig = require("@8x8/oxygen-config");

var _constants = require("../constants");

var _UserStatusIcon = _interopRequireDefault(require("./UserStatusIcon"));

var _UserStatusWrapper = _interopRequireDefault(require("../styled/UserStatusWrapper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function UserStatus(_ref) {
  var theme = _ref.theme,
      size = _ref.size,
      status = _ref.status,
      title = _ref.title,
      children = _ref.children,
      otherProps = _objectWithoutProperties(_ref, ["theme", "size", "status", "title", "children"]);

  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react["default"].createElement(_UserStatusWrapper["default"], _extends({
    size: size,
    status: status,
    title: title
  }, otherProps), children || /*#__PURE__*/_react["default"].createElement(_UserStatusIcon["default"], {
    theme: theme,
    size: size,
    status: status
  })));
}

UserStatus.propTypes = {
  /**
   * UserStatus theme
   */
  theme: _propTypes["default"].object.isRequired,

  /**
   * Define UserStatus size
   */
  size: _propTypes["default"].oneOf(Object.values(_constants.userStatusSize)),

  /**
   * Define status types
   */
  status: _propTypes["default"].oneOf(Object.values(_constants.userStatusType)),

  /**
   * Render title attribute
   */
  title: _propTypes["default"].string,

  /**
   * Overwrite icon inside UserStatus
   */
  children: _propTypes["default"].node
};
UserStatus.defaultProps = {
  size: _constants.userStatusSize.LARGE,
  status: _constants.userStatusType.AVAILABLE,
  title: undefined,
  children: undefined
};

var _default = (0, _oxygenConfig.withTheme)(UserStatus, _constants.THEME_NAME);

exports["default"] = _default;